@if (isBadgeView) {
<div [class]="'payment-entry-status-badge payment-entry-status-badge-' + statusClass" translate>{{ statusLabelCode }}</div>
} @else {
<div [class]="'payment-entry-status-text payment-entry-status-text-' + statusClass" translate>{{ statusLabelCode }}</div>
}
